 angular.module("ainapp")
     .controller("salesOrderReportController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
                function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

             $scope.PageName = "Sales Order Report";
             $scope.TokenInfo = AuthenticationService.getTokenInfo();
             if ($scope.TokenInfo == null) {
                 $state.go("login");
             } else {
                 $scope.checkUserPageAccess($scope.PageName);
             }

             $scope.Branches = [];
             MainService.BranchesInDropdown().then(function (response) {
                 var temp = {
                     Id: "",
                     Name: "All",
                 }
                 $scope.Branches = response.data;
                 $scope.Branches.push(temp);
             }, function (err) {
                 toastr.error("Network Error");
             })

             $scope.Brands = [];
             MainService.BrandsInDropdown().then(function (response) {
                 var temp = {
                     Id: "",
                     Name: "All",
                 }
                 $scope.Brands = response.data;
                 $scope.Brands.push(temp);
             }, function (err) {
                 toastr.error("Network Error");
             })

             $scope.Categories = [];
             MainService.ProductsParentList("Product").then(function (response) {
                 $scope.Categories = response.data;
             });

             $scope.GetSub = function () {
                 $scope.Parents = [];
                 MainService.ProductSubList($scope.filter.ProductGroupId, "Product").then(function (response) {
                     $scope.Parents = response.data;
                 });
             }


             $scope.IsSales = true;
             $scope.Employees = [];
             MainService.EmployeesInDropdown().then(function (response) {
                 var temp = {
                     Id: "",
                     Name: "All",
                 }
                 $scope.Employees = response.data;
                 $scope.Employees.push(temp);
             }, function (err) {
                 toastr.error("Network Error");
             })


            $scope.initDetailReport = function () {


                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                $scope.CostCenters = [];
                MainService.CostCentersInReortVoucher("Sales Order").then(function (response) {
                    $scope.CostCenters = response.data;
                })

                $scope.CurrentReportConfig = {};
                $scope.selectedItems = [];
                $scope.detailColumns = [];
                MainService.ReportConfigsbyType("Sales Order", "Detail").then(function (response3) {
                    if (response3.data != null && response3.data != "") {
                        $scope.CurrentReportConfig = response3.data;
                        var array = JSON.parse($scope.CurrentReportConfig.TableArray);
                        $scope.selectedItems = array;

                        $scope.detailColumns = angular.copy(array);

                        angular.forEach($scope.detailColumns, function (e) {
                            e.width = '100px';
                            if (e.field && e.field.includes("VoucherData")) {
                                e.field = e.field.replace("VoucherData", "SalesOrder");
                            }
                            if (e.template && e.template.includes("VoucherData")) {
                                e.template = e.template.replace("VoucherData", "SalesOrder");
                            }
                        })

                        var options = {
                            title: "Options",
                            headerTemplate: "{{LanguageData.Options}}  ",
                            template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-eye'  ng-click='View(dataItem)'></button> <button class=' btn-default btn-sm fa fa-print'  ng-click='PrintInvoice(dataItem.SalesOrderId, \"Sales Order\", dataItem.SalesOrder.VoucherNumber)'></button>",
                            width: '100px',
                            sticky: true
                        };

                        $scope.detailColumns.push(options);

                        $scope.loadKendoDetailed();
                        //                        $scope.setCostCenterCols(function () {
                        //                            $scope.loadKendoSummary();
                        //                        })
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                })

            }

             $scope.initSummaryReport = function () {

                 $.LoadingOverlay("show", {
                     image: "images/load.gif",
                 });

                 $scope.CostCenters = [];
                 MainService.CostCentersInReortVoucher("Sales Order").then(function (response) {
                     $scope.CostCenters = response.data;
                 })

                 $scope.CurrentReportConfig = {};
                 $scope.selectedItems = [];
                 $scope.summaryColumns = [];
                 MainService.ReportConfigsbyType("Sales Order", "Report").then(function (response3) {
                     if (response3.data != null && response3.data != "") {
                         $scope.CurrentReportConfig = response3.data;
                         var array = JSON.parse($scope.CurrentReportConfig.TableArray);
                         $scope.selectedItems = array;

                         $scope.summaryColumns = angular.copy(array);

                         angular.forEach($scope.summaryColumns, function (e) {
                             e.width = '100px';
                         })

                         var options = {
                             title: "Options",
                             headerTemplate: "{{LanguageData.Options}}  ",
                             template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-eye'  ng-click='View(dataItem)'></button> <button class=' btn-default btn-sm fa fa-print'  ng-click='PrintInvoice(dataItem.Id, \"Sales Order\", dataItem.VoucherNumber)'></button>",
                             width: '100px',
                             sticky: true
                         };

                         $scope.summaryColumns.push(options);

                         $scope.loadKendoSummary();
                         //                        $scope.setCostCenterCols(function () {
                         //                            $scope.loadKendoSummary();
                         //                        })
                     }
                     $.LoadingOverlay("hide");
                 }, function (err) {
                     toastr.error("Network Error");
                     $.LoadingOverlay("hide");
                 })


             }


             $scope.Init = function () {

                 $('#filterModal').modal('show');
                 var startdate = new Date(new Date().getFullYear(), 0, 1);


                 $scope.filter = {
                     CustomerName: "",
                     BranchId: "",
                     ProductName: "",
                     VoucherNo: "",
                     CustomerId: "",
                     FromDate: startdate,
                     ToDate: new Date(),
                     CustomerIds: [],
                     ProductIds: [],
                     ProductGroupId: "",
                     ProductParentId: "",
                     BrandId: "",
                 }

                 $scope.load = false;
                 $scope.isFilter = false;

                 $scope.ReportType = $stateParams.Type;
                 if ($scope.ReportType == "Detail") {
                     $scope.ReportName = "Detail";
                     $scope.initDetailReport();
                 } else if ($scope.ReportType == "PendingDetail") {
                     $scope.ReportName = "Detail (Pending)";
                     $scope.IsPending = true;
                     $scope.initDetailReport();
                 } else if ($scope.ReportType == "PendingSummary") {
                     $scope.ReportName = "Summary (Pending)";
                     $scope.IsPending = true;
                     $scope.initSummaryReport();
                 } else {
                     $scope.ReportName = "Summary";
                     $scope.initSummaryReport();
                 }

             }
             $scope.Init();

             $scope.temp = function (data, temp) {
                 console.log(data);
                 console.log(temp);
             }

             $scope.customerSelectDataSource = {
                 serverFiltering: true,
                 transport: {
                     read: function (o) {
                         if (o.data.filter != undefined) {
                             if (o.data.filter.filters.length > 0) {
                                 MainService.CustomerInAutoComplete(o.data).then(function (response) {
                                     o.success(response.data);
                                 }, function (err) {
                                     o.success({
                                         Data: []
                                     });
                                     toastr.error("Network Error");
                                 });
                             } else {
                                 o.success({
                                     Data: []
                                 });
                             }
                         } else {
                             o.success({
                                 Data: []
                             });
                         }

                     }
                 },
                 schema: {
                     data: "Data"
                 },
                 pageSize: 10
             };

             $scope.selectCustomerOptions = {
                 placeholder: "Select Accounts...",
                 dataTextField: "Name",
                 dataValueField: "Id",
                 valuePrimitive: true,
                 filter: "contains",
                 autoBind: true,
                 dataSource: $scope.customerSelectDataSource
             };


             $scope.productSelectDataSource = {
                 serverFiltering: true,
                 transport: {
                     read: function (o) {
                         if (o.data.filter != undefined) {
                             if (o.data.filter.filters.length > 0) {
                                 MainService.productInAutoComplete(o.data).then(function (response) {
                                     o.success(response.data);
                                 }, function (err) {
                                     o.success({
                                         Data: []
                                     });
                                     toastr.error("Network Error");
                                 });
                             } else {
                                 o.success({
                                     Data: []
                                 });
                             }
                         } else {
                             o.success({
                                 Data: []
                             });
                         }

                     }
                 },
                 schema: {
                     data: "Data"
                 },
                 pageSize: 10
             };

             $scope.selectProductOptions = {
                 placeholder: "Select Products...",
                 dataTextField: "Name",
                 dataValueField: "Id",
                 valuePrimitive: true,
                 autoBind: true,
                 dataSource: $scope.productSelectDataSource
             };




             $scope.loadKendoDetailed = function () {

                 $scope.KendoSource = new kendo.data.DataSource({
                     batch: true,
                     transport: {
                         read: function (o) {


                            if ($scope.isFilter) {

                                 o.data.selectedFields = [];
                                angular.forEach($scope.selectedItems, function (e) {
                                    o.data.selectedFields.push(e.field);
                                })

                                 o.data.FromDateString = $scope.extractDate($scope.filter.FromDate);
                                 o.data.ToDateString = $scope.extractDate($scope.filter.ToDate);

                                 o.data.CustomerId = $scope.filter.CustomerId;
                                 o.data.VoucherNo = $scope.filter.VoucherNo;
                                 o.data.ProductId = $scope.filter.ProductId;

                                 o.data.CustomerIds = $scope.filter.CustomerIds;
                                 o.data.ProductIds = $scope.filter.ProductIds;
                                 o.data.BranchId = $scope.filter.BranchId;
                                 o.data.CostCenters = $scope.CostCenters;
                                 o.data.IsPending = $scope.IsPending;
                                 o.data.EmployeeId = $scope.filter.EmployeeId;
                                 o.data.ProductGroupId = $scope.filter.ProductGroupId;
                                 o.data.ProductParentId = $scope.filter.ProductParentId;
                                 o.data.BrandId = $scope.filter.BrandId;

                                 MainService.SalesOrderDynamicDetailReport(o.data).then(function (response) {
                                     o.success(response.data);
                                 }, function (err) {
                                     o.success({
                                         Data: []
                                     });
                                     toastr.error("NetworkError");
                                 })
                             } else {
                                 o.success({
                                     Data: []
                                 });
                             }


                         },

                     },
                     change: function (data) {
                         if (data.items.length > 0) {
                             console.log(data);
                            
                             angular.forEach(data.items, function (e) {
                                 angular.forEach($scope.selectedItems, function (ar) {

                                     angular.forEach(e.SalesOrderCosts, function (a) {

                                         var afield = a.ParentName.replace(/ /g, '');
                                         afield = afield.replace('&', '');
                                         afield = afield.replace('/', '');
                                         afield = afield.replace('.', '');
                                         afield = "CC" + afield;

                                         if (afield == ar.field) {
                                            e[ar.field] = a.CostCenterName;
                                        }
                                     })


                                 })
                             })
                         }
                     },
                     schema: {
                         data: "Data",
                         total: "Total",
                         model: {
                             id: "Id", 
                         }
                     },
                     serverPaging: true,
                     serverSorting: true,
                     serverFiltering: true,
                     pageSize: 20,
                        aggregate: [
                            {
                                field: "Quantity",
                                aggregate: "sum"
                    },
                            {
                                field: "Cost",
                                aggregate: "sum"
                        },
                            {
                                field: "TCost",
                                aggregate: "sum"
                        },
                            {
                                field: "Total",
                                aggregate: "sum"
                        },
                            {
                                field: "TotalProfit",
                                aggregate: "sum"
                        },
                            {
                                field: "ProfitPer",
                                aggregate: "sum"
                        },
                            {
                                field: "Discount",
                                aggregate: "sum"
                        },
                            {
                                field: "TaxableAmount",
                                aggregate: "sum"
                        },
                            
                            {
                                field: "RoundOfVat",
                                aggregate: "sum"
                        },
                            {
                                field: "InventoryValue",
                                aggregate: "sum"
                        },
                            {
                                field: "OtherCharges",
                                aggregate: "sum"
                        },
                         {
                                field: "ExtraCharges",
                                aggregate: "sum"
                        }
                    ],
                 });

                 $scope.KendoGridOptions = {
                     editable: false,
                     pageable: true,
                     toolbar: ["excel"],
                     height: 700,
                     resizable: true,
                     dataSource: $scope.KendoSource,
                     pageSize: 20,
                     pageable: {
                         input: false,
                         refresh: true,
                         pageSizes: true,
                         info: true,
                     },
                     sortable: true,
                     scrollable: true,
                     filterable: true,
                     groupable: true,
                     columnMenu: {
                         filterable: false,
                         filterable: true,
                     },

                      columns: $scope.detailColumns,
                 };

             }

             $scope.loadKendoSummary = function () {

                 $scope.KendoSource2 = new kendo.data.DataSource({
                     batch: true,
                     transport: {
                         read: function (o) {

                             if ($scope.isFilter) {

                                 o.data.selectedFields = [];
                                 angular.forEach($scope.selectedItems, function (e) {
                                     o.data.selectedFields.push(e.field);
                                 })

                                 o.data.FromDateString = $scope.extractDate($scope.filter.FromDate);
                                 o.data.ToDateString = $scope.extractDate($scope.filter.ToDate);

                                 o.data.CustomerId = $scope.filter.CustomerId;
                                 o.data.VoucherNo = $scope.filter.VoucherNo;
                                 o.data.ProductId = $scope.filter.ProductId;
                                 o.data.BranchId = $scope.filter.BranchId;

                                 o.data.CustomerIds = $scope.filter.CustomerIds;
                                 o.data.ProductIds = $scope.filter.ProductIds;
                                 o.data.CostCenters = $scope.CostCenters;
                                 o.data.IsPending = $scope.IsPending;
                                 o.data.EmployeeId = $scope.filter.EmployeeId;
                                 o.data.ProductGroupId = $scope.filter.ProductGroupId;
                                 o.data.ProductParentId = $scope.filter.ProductParentId;
                                 o.data.BrandId = $scope.filter.BrandId;


                                 MainService.SalesOrderDynamicSummaryReport(o.data).then(function (response) {
                                     if (response.data != null) {
                                         o.success(response.data);
                                     } else {
                                         o.success({
                                             Data: []
                                         });
                                     }
                                 }, function (err) {
                                     o.success({
                                         Data: []
                                     });
                                     toastr.error("Network Error");
                                 })
                             } else {
                                 o.success({
                                     Data: []
                                 });
                             }


                         },

                     },
                     change: function (data) {
                         if (data.items.length > 0) {
                             console.log(data);

                             angular.forEach(data.items, function (e) {
                                 angular.forEach($scope.selectedItems, function (ar) {

                                     angular.forEach(e.SalesOrderCosts, function (a) {

                                         var afield = a.ParentName.replace(/ /g, '');
                                         afield = afield.replace('&', '');
                                         afield = afield.replace('/', '');
                                         afield = afield.replace('.', '');
                                         afield = "CC" + afield;

                                         if (afield == ar.field) {
                                             e[ar.field] = a.CostCenterName;
                                         }
                                     })


                                 })
                             })
                         }
                     },
                     schema: {
                         data: "Data",
                         total: "Total",
                         model: {
                             id: "Id",
                         }
                     },
                     serverPaging: true,
                     serverSorting: true,
                     serverFiltering: true,
                     pageSize: 20,
                     aggregate: [{
                             field: "GrossTotal",
                             aggregate: "sum"
                        },
                         {
                             field: "NetTotal",
                             aggregate: "sum"
                            }, {
                             field: "TotalDiscount",
                             aggregate: "sum"
                            },
                         {
                             field: "TotalOtherCharges",
                             aggregate: "sum"
                            },
                         {
                             field: "TotalExtraCharges",
                             aggregate: "sum"
                            },
                         {
                             field: "TotalTax",
                             aggregate: "sum"
                            }, {
                             field: "GrandTotal",
                             aggregate: "sum"
                            },
                         {
                             field: "CalcGrandTotal",
                             aggregate: "sum"
                                }, {
                             field: "TotalCost",
                             aggregate: "sum"
                                }, {
                             field: "TotalProfit",
                             aggregate: "sum"
                                }, {
                             field: "ProfitPer",
                             aggregate: "sum"
                        }],
                 });

                 $scope.KendoGridOptions2 = {

                     editable: false,
                     pageable: true,
                     toolbar: ["excel"],
                     height: 600,
                     width: "100%",
                     resizable: true,
                     dataSource: $scope.KendoSource2,
                     pageSize: 20,
                     pageable: {
                         input: false,
                         refresh: true,
                         pageSizes: true,
                         info: true,
                     },
                     sortable: true,
                     scrollable: {
                         horizontal: true
                     },
                     filterable: true,
                     groupable: true,
                     columnMenu: {
                         filterable: false,
                         filterable: true,
                     },


                     columns: $scope.summaryColumns,
                 };


             }


             $scope.Edit = function (data) {
                 if ($scope.ReportType == "Detail") {
                     $state.go("editSalesOrder", {
                         VoucherId: data.SalesOrderId
                     })
                 } else {
                     $state.go("editSalesOrder", {
                         VoucherId: data.Id
                     })
                 }
             }

             $scope.View = function (data) {
                 if ($scope.ReportType == "Detail") {
                     $state.go("viewSalesOrder", {
                         VoucherId: data.SalesOrderId
                     })
                 } else {
                     $state.go("viewSalesOrder", {
                         VoucherId: data.Id
                     })
                 }
             }

             $scope.OpenFilter = function () {
                 $('#filterModal').modal('show');
             }

             $scope.GetReport = function () {
                 $scope.isFilter = true;
                 $('#filterModal').modal('hide');
                 $("#Kendo-Grid").data("kendoGrid").dataSource.read();
             }

             $scope.Refresh = function () {
                 $scope.Init();
                 $scope.isFilter = true;
                 $("#Kendo-Grid").data("kendoGrid").dataSource.read();
             }

             $scope.print = function () {

                 $scope.filter.FromDateString = $scope.extractDate($scope.filter.FromDate);
                 $scope.filter.ToDateString = $scope.extractDate($scope.filter.ToDate);

                 $scope.filter.CostCenters = $scope.CostCenters;

                 if ($scope.ReportType == "Detail") {

                     MainService.PrintSalesOrderReport($scope.filter).then(function (response) {
                         if (response.data != null) {
                             $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                         } else {
                             toastr.error("Network Error");
                         }
                         $scope.Load = false;
                     }, function (err) {
                         toastr.error("Network Error");
                         $scope.Load = false;
                     })

                 } else {

                     MainService.PrintSalesOrderSummaryReport($scope.filter).then(function (response) {
                         if (response.data != null) {
                             $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                         } else {
                             toastr.error("Network Error");
                         }
                         $scope.Load = false;
                     }, function (err) {
                         toastr.error("Network Error");
                         $scope.Load = false;
                     })

                 }



             }


                 }])
